module.exports = __webpack_public_path__ + "img/ico_arrow_down_white.bf390ade.svg";